import { render, staticRenderFns } from "./floatButton2.vue?vue&type=template&id=f3458356&scoped=true"
import script from "./floatButton2.vue?vue&type=script&lang=js"
export * from "./floatButton2.vue?vue&type=script&lang=js"
import style0 from "./floatButton2.vue?vue&type=style&index=0&id=f3458356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3458356",
  null
  
)

export default component.exports